<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="Stay_instruction"
    :submit="submit" :status="status" :breadcrumbs="[
      {
        text: 'Reservas y estadías',
        disabled: false,
        href: '/admin/stay_instructions'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <div class="label-base pb-1">Titulo</div>
              <ValidationProvider ref="title" rules="" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model="data.title" label="Titulo" type="text" solo
                  hide-details="auto" class="input-base">
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Descripción</div>
                <v-textarea :error-messages="errors" v-model="data.description" solo placeholder="Descripción"
                  hide-details="auto" class="text-tarea-base" rows="8" />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="animation" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Animación</div>
                <Upload :error-messages="errors" accept="image/*,video/*" placeholder="Animación"
                  prepend-icon="fas fa-camera" label="" :multiple="false" :onSelectedPicture="onSelectedPicture">
                </Upload>

                <template v-if="animation">
                  <template v-if="is_video == false">
                    <img width="200" style="margin: auto" :src="animation" alt="Profile Picture" />
                  </template>
                  <template v-else-if="is_video">
                    <video width="100%" controls>
                      <source :src="animation" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </template>
                </template>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import Upload from "@/components/Upload";
export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm, Upload },
  computed: {
    ...mapState({
      status: (state) => state.Stay_instructions.status,
    }),
  },
  mounted() {
    if (this.isImage(this.data.animation)) {
      this.is_video = false;
    } else if (this.isVideo(this.data.animation)) {
      this.is_video = true;
    }
  },
  watch: {
    animation: function (newval) {
      if (this.isImageUrl(newval)) {
        this.is_video = false;
      } else if (this.isVideoUrl(newval)) {
        this.is_video = true;
      }
    },
  },
  data() {
    return {
      storeName: "Stay_instructions",
      title: "Instrucciones",
      filteredAttributes: ["animation"],
      animation: "",
      is_video: false,
      data: {
        title: "",
        animation: undefined,
        description: "",
      },
    };
  },
  methods: {
    onSelectedPicture(file) {
      const self = this;
      this.data.animation = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.animation = fr.result;
        if (self.isImage(file.type)) {
          self.is_video = false;
          // Aquí puedes hacer algo específico para imágenes, si es necesario
        } else if (self.isVideo(file.type)) {
          self.is_video = true;
        }
      };
      fr.onerror = function () {
        self.animation = "";
      };
      fr.readAsDataURL(this.data.animation);
    },
    isImage(type) {
      return type.startsWith("image/");
    },

    isVideo(type) {
      return type.startsWith("video/");
    },
    isImageUrl(url) {
      return /\.(gif|jpe?g|png|bmp|webp|svg)$/i.test(url);
    },
    isVideoUrl(url) {
      return /\.(mp4|mkv|webm|ogg|avi)$/i.test(url);
    },
  },
};
</script>
